import { render, staticRenderFns } from "./LeadPage.vue?vue&type=template&id=5b59f92c&scoped=true&lang=html&"
import script from "./LeadPage.vue?vue&type=script&lang=js&"
export * from "./LeadPage.vue?vue&type=script&lang=js&"
import style0 from "./LeadPage.vue?vue&type=style&index=0&id=5b59f92c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59f92c",
  null
  
)

export default component.exports